import React, { Component } from "react";
import Filter from "../Filter/Filter";
import "./Stories.css";
import Dialog from "../Dialog/Dialog";
import Connection from "../../classes/Connection";

class Stories extends Component {
    constructor(props) {
        super(props);
        this.newMediaInputRef = React.createRef();
        this.onSave = this.onSave.bind(this);
        this.get_all_stories = this.get_all_stories.bind(this);
        this.save_new_arrange = this.save_new_arrange.bind(this);
    }
    state = {
        stories: [],
        newStory: { media: null, name: null, description: null },
        edittingStoryIndex: -1,
        newWindowOpen: false,
        dragingItem: null,
        rearanged: false,
    };

    componentDidMount() {
        this.get_all_stories();
    }

    get_all_stories() {
        const { toast, connection } = this.props;

        connection
            .get_all_stories()
            .then((res) => {
                this.setState({ stories: res.data });
            })
            .catch((res) => {
                toast(
                    "خطا در دریافت اطلاعات",
                    "خطا در دریافت استوری ها",
                    " danger "
                );
            });
    }

    uploadFiles(files) {
        return new Promise((resolve, reject) => {
            if (files.length === 0) resolve([]);
            this.props.connection
                .upload(files, (results, reqs) => {
                    this.setState({
                        dialog: (
                            <Dialog
                                message={
                                    "در حال آپلود فایل ها لطفا منتظر بمانید ..."
                                }
                                progress={{
                                    current: results.length,
                                    total: reqs.length,
                                }}
                            ></Dialog>
                        ),
                    });
                })
                .then((results) => {
                    this.props.toast(
                        "آپلود",
                        "تمام فایل ها با موفقیت آپلود شدند",
                        " confirm"
                    );
                    resolve(results);
                })
                .catch((err) => {
                    this.props.toast(
                        "خطا در آپلود فایل ها",
                        `آپلود با خطا مواجه شد لطفا مجددا تلاش کنید\n
                                            خطا:\n
                                            ${err.code}\n
                                            ${err.name}\n
                                            ${err.message}\n
                                            `,
                        " danger"
                    );
                    reject(err);
                });
        });
    }

    onSave() {
        const { toast, connection } = this.props;

        let { edittingStoryIndex, newStory } = this.state;
        if (edittingStoryIndex) {
            this.uploadFiles([newStory.media.file])
                .then((res) => {
                    newStory.media.url = res[0].url;
                    delete newStory.media.file;
                    connection
                        .add_story(newStory)
                        .then((res) => {
                            this.setState({ newWindowOpen: false });
                            this.get_all_stories();

                            toast(
                                "افزودن استوری",
                                "استوری جدید با موفقیت اضافه شد.",
                                " confirm "
                            );
                        })
                        .catch((res) => {
                            console.log(res);
                            toast(
                                "افزودن استوری",
                                "خطا دز افزودن استوری.\n" + res.message,
                                " danger "
                            );
                        });
                })
                .catch((res) => {});
        } else if (newStory.media.file) {
            this.uploadFiles([newStory.media.file])
                .then((res) => {
                    newStory.media.url = res[0].url;
                    delete newStory.media.file;
                    connection
                        .edit_story(newStory)
                        .then((res) => {
                            this.setState({ newWindowOpen: false });
                            this.get_all_stories();

                            toast(
                                "ویرایش استوری",
                                "استوری  با موفقیت ویرایش شد.",
                                " confirm "
                            );
                        })
                        .catch((res) => {
                            console.log(res);
                            toast(
                                "ویرایش استوری",
                                "خطا دز ویرایش استوری.\n" + res.message,
                                " danger "
                            );
                        });
                })
                .catch((res) => {});
        } else {
            connection
                .edit_story(newStory)
                .then((res) => {
                    this.setState({ newWindowOpen: false });
                    this.get_all_stories();

                    toast(
                        "ویرایش استوری",
                        "استوری  با موفقیت ویرایش شد.",
                        " confirm "
                    );
                })
                .catch((res) => {
                    console.log(res);
                    toast(
                        "ویرایش استوری",
                        "خطا دز ویرایش استوری.\n" + res.message,
                        " danger "
                    );
                });
        }
    }

    save_new_arrange() {
        const { toast, connection } = this.props;
        connection
            .save_new_stories_arrange(this.state.stories)
            .then((res) => {
                toast(
                    "ذخیره چیدمان استوری ها",
                    "چینش جدید استوری ها ذخیره شد.",
                    " confirm"
                );
                this.setState({ rearanged: false });
            })
            .catch((err) => {
                toast(
                    "ذخیره چیدمان استوری ها",
                    "خطا در ذخیره چینش جدید استوری ها : \n." + err.message,
                    " danger"
                );
            });
    }

    render() {
        let { stories, newStory, newWindowOpen, dragingItem, rearanged } =
            this.state;
        return (
            <div className='StoriesComponent'>
                <Filter></Filter>
                {!rearanged && (
                    <div className={`new ${newWindowOpen && "open"}`}>
                        <div
                            className='add btn info'
                            onClick={(ev) => {
                                this.setState({ newWindowOpen: true });
                            }}
                        >
                            استوری جدید
                        </div>
                        {newWindowOpen && (
                            <div className='container'>
                                <div className='preview'>
                                    {newStory && newStory.media ? (
                                        newStory.media.type == "video" ? (
                                            <video
                                                src={newStory.media.url}
                                                autoPlay
                                                controls
                                            ></video>
                                        ) : (
                                            <img
                                                src={newStory.media.url}
                                                alt=''
                                            />
                                        )
                                    ) : (
                                        <div className='empty'>
                                            یک عکس یا فیلم از طریق دکمه پایین
                                            انتخاب کنید.
                                        </div>
                                    )}
                                </div>
                                <div
                                    className='media'
                                    onClick={(ev) => {
                                        this.newMediaInputRef.current.click();
                                    }}
                                >
                                    انتخاب رسانه
                                    <div className='text warning type'>
                                        ( تصویر یا فیلم )
                                    </div>
                                    <input
                                        type='file'
                                        accept='image/*, video/*'
                                        ref={this.newMediaInputRef}
                                        multiple={false}
                                        onChange={(ev) => {
                                            const file = ev.target.files[0];
                                            let newStory =
                                                this.state.newStory || {};
                                            newStory.media = {
                                                url: URL.createObjectURL(file),
                                                type: file.type.includes(
                                                    "image"
                                                )
                                                    ? "image"
                                                    : "video",
                                                file,
                                            };
                                            file &&
                                                this.setState({
                                                    newStory,
                                                });
                                        }}
                                    />
                                </div>
                                <div className='name'>
                                    نام استوری
                                    <div className='text info optional'>
                                        اختیاری
                                    </div>
                                    <input
                                        className="!bg-red-200 rounded-lg"
                                        type='text'
                                        defaultValue={
                                            this.state.newStory &&
                                            this.state.newStory.name
                                        }
                                        onChange={(ev) => {
                                            let { newStory } = this.state;
                                            newStory.name = ev.target.value;
                                            this.setState({ newStory });
                                        }}
                                    />
                                </div>
                                <div className='description flex !flex-col w-full'>
                                    توضیح استوری
                                    <div className='text info optional'>
                                        اختیاری
                                    </div>
                                    <textarea
                                    className="!bg-red-200 rounded-lg !w-full"
                                        defaultValue={
                                            this.state.newStory &&
                                            this.state.newStory.description
                                        }
                                        onChange={(ev) => {
                                            let { newStory } = this.state;
                                            newStory.description =
                                                ev.target.value;
                                            this.setState({ newStory });
                                        }}
                                    ></textarea>
                                </div>
                                <div className='actions flex !flex-col'>
                                    <div
                                        className='save btn confirm'
                                        onClick={this.onSave}
                                    >
                                        ذخیره
                                    </div>

                                    <div
                                        className='save btn danger'
                                        onClick={(ev) =>
                                            this.setState({
                                                newStory: null,
                                                edittingStoryIndex: -1,
                                                newWindowOpen: false,
                                            })
                                        }
                                    >
                                        لغو
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {rearanged && (
                    <div className='rearrangment'>
                        <div
                            className='saveNewArrange btn confirm '
                            onClick={this.save_new_arrange}
                        >
                            ذخیره چینش جدید
                        </div>
                        <div
                            className='saveNewArrange btn danger '
                            onClick={(ev) => {
                                this.setState({ rearanged: false });
                                this.get_all_stories();
                            }}
                        >
                            لغو چینش جدید
                        </div>
                    </div>
                )}
                <div className='stories'>
                    {stories && stories.length > 0 ? (
                        <div className='list'>
                            {stories.map((s, i) => {
                                return (
                                    <div
                                        className='story'
                                        key={s.id}
                                        draggable
                                        onDragStart={(ev) => {
                                            this.setState({
                                                dragingItem: s,
                                            });
                                        }}
                                        onDragOver={(ev) => {
                                            ev.preventDefault();
                                        }}
                                        onDrop={(ev) => {
                                            ev.preventDefault();
                                            const dragginIndex =
                                                stories.findIndex((_s) => {
                                                    return (
                                                        _s.id === dragingItem.id
                                                    );
                                                });
                                            stories.splice(dragginIndex, 1);

                                            const dropedIndex =
                                                stories.findIndex((_s) => {
                                                    return _s.id === s.id;
                                                });

                                            dropedIndex >= dragginIndex
                                                ? (stories = [
                                                      ...stories.slice(
                                                          0,
                                                          dropedIndex + 1
                                                      ),
                                                      dragingItem,
                                                      ...stories.slice(
                                                          dropedIndex + 1
                                                      ),
                                                  ])
                                                : (stories = [
                                                      ...stories.slice(
                                                          0,
                                                          dropedIndex
                                                      ),
                                                      dragingItem,
                                                      ...stories.slice(
                                                          dropedIndex
                                                      ),
                                                  ]);

                                            this.setState({
                                                stories,
                                                dragingItem: null,
                                                rearanged: true,
                                            });
                                        }}
                                    >
                                        <div className='preview'>
                                            {s.media.type === "video" ? (
                                                <video
                                                    src={s.media.url}
                                                    autoPlay={false}
                                                    loading='lazy'
                                                    draggable='false'
                                                ></video>
                                            ) : (
                                                <img
                                                    src={s.media.url}
                                                    loading='lazy'
                                                    draggable='false'
                                                />
                                            )}
                                        </div>
                                        <div className='name'>{s.name}</div>
                                        <div className='actions'>
                                            <div
                                                className='edit'
                                                onClick={(ev) => {
                                                    ev.stopPropagation();
                                                    this.setState({
                                                        newWindowOpen: true,
                                                        edittingStoryIndex: i,
                                                        newStory: s,
                                                    });
                                                }}
                                            >
                                                <i class='ri-pencil-line text info'></i>
                                            </div>
                                            <div
                                                className='delete'
                                                onClick={(ev) => {
                                                    ev.stopPropagation();

                                                    this.props.connection
                                                        .delete_story(s.id)
                                                        .then((res) => {
                                                            this.props.toast(
                                                                "حذف استوری",
                                                                "استوری حذف شد",
                                                                " confirm "
                                                            );
                                                            this.get_all_stories();
                                                        })
                                                        .catch((res) => {
                                                            this.props.toast(
                                                                "حذف استوری",
                                                                "استوری حذف نشد" +
                                                                    res.message,
                                                                " danger "
                                                            );
                                                            this.get_all_stories();
                                                        });
                                                }}
                                            >
                                                <i className='ri-delete-bin-7-fill fa-trash-can text danger'></i>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        <div className='empty'>هیچ استوری موجود نیست.</div>
                    )}
                </div>
            </div>
        );
    }
}

export default Stories;
